var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      class: [
        "home-nav sticky-element sticky-element-start card display-none tablet:display-none laptop:display-flex flex-wrap align-center tablet:align-between",
        { "is-stuck with-shadow": _vm.isStickyElementStuck },
      ],
      staticStyle: {
        "--link-decoration-line": "none",
        "--with-shadow-box-shadow-width": "var(--spacing-3xs)",
        "--card-horizontal-padding": "var(--spacing-3xl)",
        "--card-vertical-padding": "var(--spacing-xl)",
        "--with-shadow-box-shadow":
          "0 var(--with-shadow-box-shadow-width) 0 var(--card-link-box-shadow-color)",
        "z-index": "var(--depth-2)",
      },
      attrs: { id: "home-nav" },
    },
    [
      _c(
        "div",
        [
          _c(
            "site-link",
            {
              staticClass:
                "display-block margin-xs laptop:margin-0 margin-xs no-underline",
              attrs: { to: { hash: "#fa7" } },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-4xs",
                attrs: { icon: _vm.$v7.solid.faSparkles, size: "lg" },
              }),
              _vm._v("\n      Font Awesome 7\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "site-link",
            {
              staticClass:
                "display-block margin-xs laptop:margin-0 no-underline",
              attrs: { to: { hash: "#pro-plus" } },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "display-inline-block margin-right-4xs",
                attrs: { icon: _vm.$v7.solid.faShapes, size: "lg" },
              }),
              _vm._v("\n      New Icon Packs\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "site-link",
            {
              staticClass:
                "display-block margin-y-xs margin-x-xs tablet:margin-y-0 tablet:margin-x-0 no-underline",
              attrs: { to: { hash: "#tech" } },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "display-inline-block margin-right-4xs",
                attrs: { icon: _vm.$v7.solid.faWrenchSimple, size: "lg" },
              }),
              _vm._v("\n      Tech Updates\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "site-link",
            {
              staticClass:
                "display-block margin-y-xs margin-x-xs tablet:margin-y-0 tablet:margin-x-0 no-underline",
              attrs: { to: { hash: "#styling" } },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "display-inline-block margin-right-4xs",
                attrs: { icon: _vm.$v7.solid.faPalette, size: "lg" },
              }),
              _vm._v("\n      Styling Toolkit\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "site-link",
            {
              staticClass:
                "display-block margin-y-xs margin-x-xs tablet:margin-y-0 tablet:margin-x-0 no-underline",
              attrs: { to: { hash: "#pro-vs-pro-plus" } },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "display-inline-block margin-right-4xs",
                attrs: { icon: _vm.$v7.solid.faRightLeft, size: "lg" },
              }),
              _vm._v("\n      Pro vs Pro+\n    "),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }